export default __webpack_public_path__ + "static/media/ankit.97179d51.png";